export type BaseElement = { id: string; group?: string };
export type BaseArray = BaseElement[];
type BaseArrayArray = BaseArray[];

export function isOptionEqualToValue<T extends BaseElement>(
  option: T,
  value: T,
) {
  return option.id === value.id;
}

/**
 * Concat multiple selector `value` with paginated data.
 * @param {BaseArrayArray} paginatedData
 * @param {BaseArray} value
 * @returns
 */
export function mergePaginatedDataAndValue<
  P extends BaseArrayArray,
  V extends BaseArray,
>(paginatedData: P, value: V, getValueKey?: (value: V[number]) => string) {
  const flattedPaginatedData = paginatedData.flat();
  const options = [
    ...value,
    ...flattedPaginatedData.filter(
      (u) =>
        !value
          .map((i) => (getValueKey ? getValueKey(i) : i.id))
          .includes(getValueKey ? getValueKey(u) : u.id),
    ),
  ];
  return options;
}
